 <!-------------Hero SLider Start----------------->
 <div class="hero__slider" style="background-image: url(images/hero__bg.jpg);">
    <div class="hero__slider__inner">
      <div class="container">
        <div class="hero__slider__text">
          <h1>The Wellbux APP</h1>
          <p>Wellbux offers thousands of deals from your local stores on anything you buy. Resturants, Hotels, Groceries, Clothing Stores, Wellbux have covered all these for you</p>
          <div class="app__download__btn">
            <div class="appstore__btn playstore">
              <a href="#"><img src="/assets/images/google-play-store.png" /></a>
            </div>
            <div class="appstore__btn appstore">
              <a href="#"><img src="/assets/images/app-store.png" /></a>
            </div>
          </div>
        </div>
        <div class="hero__slider__box">

          <carousel>
            <slide>
              <img src="/assets/images/slider-1.png" alt="First slide">
            </slide>
            <slide>
              <img src="/assets/images/slider-2.png" alt="First slide">
            </slide>
            <slide>
              <img src="/assets/images/slider-3.png" alt="First slide">
            </slide>
          </carousel>


        </div>
      </div>
    </div>
  </div>
  <!-------------Hero SLider End----------------->
